import axiosInstance from "../axiosInstance";
import { ApiResponse } from "@/types/apiResponse";

/**
 * The branches (GATE papers) the user is studying for.
 *
 * The list is ordered and index 0 is the primary branch — the one the home
 * page and the nav pill are built around. "Make primary" is expressed as a
 * reorder of the whole list rather than a flag, so there is never more than
 * one primary and never none.
 *
 * An empty list is a legitimate state: users who signed up before branches
 * existed and whose branch could not be inferred have none yet. Every
 * caller must handle that rather than assuming `[0]` exists.
 */
export interface Branch {
  subject_id: string;
  subject_code: string;
  subject_name: string;
  position: number;
  is_primary: boolean;
  /** 0 means the branch has no papers yet — "coming soon". */
  paper_count: number;
}

export const branchesKey = ["me", "branches"] as const;

export const getMyBranches = async (): Promise<ApiResponse<Branch[]>> => {
  const res = await axiosInstance.get("/me/branches");
  return res.data;
};

export const addMyBranch = async (
  subject_id: string,
): Promise<ApiResponse<Branch[]>> => {
  const res = await axiosInstance.post("/me/branches", { subject_id });
  return res.data;
};

/** Replace the whole ordered list. Index 0 becomes the primary. */
export const setMyBranches = async (
  subject_ids: string[],
): Promise<ApiResponse<Branch[]>> => {
  const res = await axiosInstance.put("/me/branches", { subject_ids });
  return res.data;
};

export const removeMyBranch = async (
  subject_id: string,
): Promise<ApiResponse<Branch[]>> => {
  const res = await axiosInstance.delete(`/me/branches/${subject_id}`);
  return res.data;
};
